import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../utils/Image';

import './icon-text.css';

const IconText = ({ icon, text }) => (
  <figure className="icon-text">
    <Image src={icon} className="icon-text-image" />
    <figcaption className="icon-text-text" dangerouslySetInnerHTML={{ __html: text }} />
  </figure>
);

IconText.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default IconText;
